import { makeStyles, createStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => createStyles({
    avatar: {
        borderRadius: 4,
        height: 30,
        width: 30
    }
}));